import LocalizedStrings from "react-localization";
import { UnitType, DeleteUnitReason } from "../units/UnitModels";
import { DeleteReason, TruckProperties } from "../trucks/TruckModels";
import { DayOfWeek, CompanyIndustryType, FilterTarget } from "../common/models/CommonModels";
import { DayRule, DayRuleDay } from "../common/models/Recurrence";

export const localizations = new LocalizedStrings({
    fi: {
        common: {
            name: "Nimi",
            firstName: "Etunimi",
            lastName: "Sukunimi",
            streetAddress: "Katuosoite",
            postCode: "Postinumero",
            city: "Toimipaikka",
            title: "NuppiAppi",
            companyName: "Yrityksen nimi",
            businessId: "Y-tunnus",
            organizer: "Ajojärjestelijä",
            website: "Kotisivu",
            phoneNumber: "Puhelinnumero",
            phoneNumberDetails: "Puhelinnumeron selite",
            email: "Sähköposti",
            emailDetails: "Sähköpostin selite",
            properties: "Ominaisuudet",
            details: "Lisätiedot",
            pointOfDeparture: "Lähtöpaikka",
            pointOfArrival: "Saapumispaikka",
            transportCoordinator: "Ajojärjestelijä",
            type: "Kuljetusyksikkö",
            reporter: "Ilmoittaja",
            allSelection: "Kaikki",
            contactPerson: "Yhteyshenkilö",
            startTime: "Alkuaika",
            endTime: "Loppuaika",
            hankoString: "Hanko",
            showOnTable: "Näytä listalla",
            deletedAt: "Poistettu",
            reason: "Syy",
            reportNumber: "Ilmoituksen numero (Id)",
            reportNumberCol: "Id",
            todayLabel: "Tämä päivä",
            contractPriceCol: "Alustava hinta",
            totalPrice: "Reitin hinta" ,
            definition: "Selite",
            postalCity: "Postitoimipaikka",
            companyIdentifier: "Yrityksen tunniste",
            companyAd: "Yrityksen ilmoitus",
            new: "Uusi!",
            generalSearchField: "Haku",
            timeLeft: "Jäljellä",
            left: "jäljellä",
            speedUsedForCalc: "(80 km/h)",
            h: "h",
            min: "min",
            filterName: "Filtterin nimi",
            filterTarget: "Filtterin haun kohde",
            emailTracking: "Seurannassa (lähettää sähköpostia)",
            tracking: "Seurannassa",
            notTracking: "Ei seurannassa",
            filter: "Filtteri",
            announcementCountTitle: "Ilmoitukset",
            announcementCount: "Ilmoituksia",
            announcementShortCount: "Ilmoituksia",
            searchDistance: "Seurannan etäisyys (km)",
            activateDistanceCheck: "Aktivoi seuranta",
            activateUnitCheckTooltip: "Automaattinen seuranta lähettää sinulle sähköpostia, jos UnitSpotterista löytyy tähän ilmoitukseen sopivaa kalustoa.",
            activateTruckCheckTooltip: "Automaattinen seuranta lähettää sinulle sähköpostia, jos UnitSpotterista löytyy tähän ilmoitukseen sopivaa rahtia.",
            trackingNotActivated: "Seurantaa ei ole aktivoitu",
            trackingActivated: "Seuranta aktivoitu, etäisyys",
            km: "km",
            user: "Käyttäjä"
        },
        paging: {
            rowsPerPage: "Riviä per sivu",
            page: "Sivu",
            rows: {
                fiveRows: "5 riviä",
                tenRows: "10 riviä",
                twentyRows: "20 riviä",
                twentyFiveRows: "25 riviä",
                fiftyRows: "50 riviä",
                hundredRows: "100 riviä",
                rows: "Riviä"
            },
        },
        mediaPageView: {
            title: "Medialle",
            linkText: "Medialle",
            notice: "Huomaa",
            noticeParagraph01: "Huomaathan, että kaikki UnitSpotterin sisältö on tekijänoikeuslain suojaamaa. Laki koskee myös grafiikkaa ja logoja.",
            noticeParagraph02: "Sinulla on oltava lupa, jos haluat käyttää UnitSpotterin brändiä tai sen elementtejä, kuten logoja. Pyydä lupa materiaalin käyttöön osoitteesta support@unitspotter.fi",
            noticeParagraph03: "Huomaathan myös, että UnitSpotter kirjoitetaan UnitSpotter, ei Unitspotter.",
            logoUsage: "Logojen käyttö",
            logoUsageParagraph01: "Logon suoja-alueen sisälle ei saa sijoittaa tekstiä, logoja, grafiikkaa tai muuta sisältöä. Logon suoja-alue on korkeussuunnassa 33% logon korkeudesta ja leveyssuunnassa 9% logon leveydestä.",
            logoUsageParagraph02: "Logon muotoa, asettelua, osia, suoja-alueen kokoa tai värejä ei saa muuttaa.",
            logoUsageParagraph03: "Logosta löytyy värillinen versio jossa logon alkuosa ”UNIT” on joko musta tai valkoinen. Logosta löytyy myös mustavalkoinen versio. Värillistä logoa käytetään pääsääntöisesti markkinoinnisssa. Mustavalkoista verisiota tulee käyttää vain mustavalkopainatuksissa.",
            logoLoading: "Ladattavat logot",
            logoLoadingParagraph01: "Logot ovat ladattavissa .png muodossa pienemmässä (322x84 pikseliä) ja suuremmassa (827x215 pikseliä) koossa. Lisäksi saatavilla on vektoriversiot logoista PDF-muodossa.",
            logoLoadingRGBVersion: "Logon RGB-versio PDF-muodossa",
            logoLoadingAllLogos: "Lataa logon kaikki versiot PDF-muodossa",
            logoLoadingSmallVersion: "Lataa logon pieni versio (.png)",
            logoLoadingLargeVersion: "Lataa logon suuri versio (.png)",
            serviceBrand: "Palvelun brändivärit",
            serviceBrandParagraph01: "Tästä löydät palvelun brändivärit rgb- ja heksadesimaalimuodossa",
            serviceBrandColorTitle01: "Brändiväri 1",
            serviceBrandColorRGB01: "rgb(64,166,174)",
            serviceBrandColorHex01: "#40A6AE",
            serviceBrandColorTitle02: "Brändiväri 2",
            serviceBrandColorRGB02: "rgb(44,116,121)",
            serviceBrandColorHex02: "#2C7479",
            serviceBrandColorTitle03: "Brändiväri 3",
            serviceBrandColorRGB03: "rgb(255,255,255)",
            serviceBrandColorHex03: "#FFFFFF",
            screenCaptures: "Kuvakaappaukset palvelusta",
            screenCapturesParagraph01: "Tästä löydät kuvakaappauksia palvelusta.",
            rows: {
                fiveRows: "5 riviä",
                tenRows: "10 riviä",
                twentyRows: "20 riviä",
                twentyFiveRows: "25 riviä",
                fiftyRows: "50 riviä",
                hundredRows: "100 riviä",
                rows: "Riviä"
            },
        },
        register: {
            registerUserTitle: "Rekisteröidy käyttäjäksi",
            registerCompanyTitle: "Rekisteröi yritys",
            continueToLogin: "Jatka kirjautumiseen",
            registeringSuccessfulParagraph: "Sinulle lähetetään tieto rekisteröitymisestä sekä väliaikainen salasana antamaasi sähköpostiosoitteeseen. Ensimmäisellä kirjautumiskerralla pääset vaihtamaan salasanasi uuteen.",
            thanksForRegistering: "Kiitos rekisteröitymisestä!",
            doNotHaveIdentifier: "Minulla ei ole vielä tunnistetta - haluan rekisteröidä uuden yrityksen",
            continueToFrontPage: "Jatka etusivulle",
            companyRegisterSuccessful: "Yrityksesi rekisteröitymispyyntö on nyt lähetetty palvelun ylläpitäjälle. Tieto hyväksymisestä lähetetään yhteyshenkilön sähköpostiosoitteeseen muutaman arkipäivän kuluessa.",
            registerCompanyStepOne: "Täytä ensin yrityksesi tiedot. Tämän jälkeen pääset syöttämään omat tai yrityksen muun yhteyshenkilön tiedot.",
            registerCompanyStepTwo: "Täytä tähän omat tai muun yrityksen yhteyshenkilön tiedot. Sisäänkirjautuminen tapahtuu tässä antamallasi sähköpostiosoitteella.Yhteyshenkilö saa sähköpostiinsa tunnuksen, jonka avulla muut yrityksen henkilöt pääsevät rekisteröitymään palveluun",
            didYouForgetPassword: "Unohditko salasanasi?",
            ifIdentifierMissing: "Olet saanut yrityksesi yhteyshenkilöltä tunnisteen, jolla pääset rekisteröitymään palvelun käyttäjäksi. Mikäli sinulla ei ole tunnistetta, käänny yrityksesi yhteyshenkilön puoleen.",
            newPassword: "Ei hätää. Kirjoita käyttäjätunnuksenasi käyttämäsi sähköpostiosoite, niin lähetämme sinulle väliaikaisen salasanan.",
            privacy: "Yksityisyytesi ja tietojesi suojaaminen on meille tärkeää. Lue lisää",
            privacyPolicy: "tietosuojalausekkeestamme.",
            noAddedCoordinators: "Ei liitettyjä ajojärjestelijöitä"

        },
        account: {
            personalReports: "Omat ilmoitukset",
        },
        landingPageView: {
            statistics: {
                text1: "rekisteröitynyttä yritystä",
                text2: "ilmoitusta jätetty"
            },
            infoItems: {
                title1: "Kustannusten vähentyminen",
                content1: "UnitSpotter parantaa kuljetuskaluston kustannustehokkuutta lisäämällä toimijoiden välistä yhteistyötä ja vähentämällä tyhjiä ajoja.",
                title2: "Toimitusaikojen parantuminen",
                content2: "Palvelu parantaa yrityksesi toimitusaikoja hyödyntämällä ajallisesti ja sijainniltaan sopivaa vapaata kalustoa.",
                title3: "Työn tehostuminen",
                content3: "UnitSpotter tehostaa ajojärjestelijöiden työtä nopeuttamalla sopivan kaluston löytymistä vähentämällä turhaa työtä ja soittokierroksia.",
                title4:"Kokonaispäästöjen vähentyminen",
                content4: "Eurostatin tilastot osoittavat, että Suomen kotimaan kuljetuksissa noin viidennes kilometreistä ajetaan tyhjinä. Liikenteen kasvihuonepäästöistä tieliikenteen osuus on jopa 95%. Ei-toivotun tyhjäajon vähentäminen vähentää päästöjä ja tiestön kulumista.",
            },
            quotes: {
                text1: "Käytimme ennen ajojen järjestelyyn puhelimitse ja sähköpostitse paljon aikaa. UnitSpotterin avulla ajojärjestelijämme työ on helpottunut ja toimintamme tehostunut!",
                name1: "Aino Ajojärjestelijä, Kuljetusliike Oy",
                text2: "Käytimme ennen ajojen järjestelyyn puhelimitse ja sähköpostitse paljon aikaa.",
                name2: "Aino Ajojärjestelijä, Kuljetusliike Oy",
                text3: "UnitSpotterin avulla ajojärjestelijämme työ on helpottunut ja toimintamme tehostunut!",
                name3: "Aino Ajojärjestelijä, Kuljetusliike Oy",
                text4: "Käytimme ennen ajojen järjestelyyn puhelimitse ja sähköpostitse paljon aikaa. UnitSpotterin avulla ajojärjestelijämme työ on helpottunut ja toimintamme tehostunut!",
                name4: "Aino Ajojärjestelijä, Kuljetusliike Oy",
                text5: "Käytimme ennen ajojen järjestelyyn puhelimitse ja sähköpostitse paljon aikaa.",
                name5: "Aino Ajojärjestelijä, Kuljetusliike Oy",
            },
            faqItems: {
                title1: "Millä alueilla UnitSpotter toimii?",
                content1: "UnitSpotter toimii koko Suomessa. Oli kuljetustarpeesi Suomessa mihin suuntaan tahansa, voit ilmoittaa siitä UnitSpotteriin.",
                title2: "Voinko jotenkin rajoittaa ketkä näkevät ilmoitukseni?",
                content2: "Asetuksissa voit valita näkyvyysrajoitettujen listalle ne yritykset joille et halua ilmoituksesi näkyvän. Tämä tosin estää vastaavasti sinua näkemästä listalle valitsemasi yritysten tekemät ilmoitukset. Näkyvyyden rajoittaminen heikentää yhteistyömahdollisuuksiasi joten käytä toimintoa harkiten.",
                title3: "Meillä ei ole omia kalustoja, vaan kaikki ringissämme ajavat on ostettu alihankintana. Miten suhtaudutte siihen, jos ilmoitamme yhteistyössä ko. yritysten kanssa heidän kalustoja meidän nimissä UnitSpotteriin?",
                content3: "Alihankinnassa olevan kaluston yrityksen nimi voidaan ilmoittaa kalustoilmoituksessa kenttässä nimeltä ”Kuljetusliike”. Tämä antaa vastapuolelle mahdollisuuden nähdä mikä yritys suorittaisi ajon.",
                title4: "Onko teillä näkemyksiä vastuu- tai muista kysymyksistä jos ilmoittaa alihankinnassa olevan kaluston järjestelmään?",
                content4: "Ilmoittaja vastaa aina järjestelmään ilmoitetuista tiedoista ja toimii myös yhteyshenkilönä koskien ilmoitettua kohdetta. Alihankinnassa olevien kalustojen ilmoittaminen tulee tapahtua yhteisymmärryksessä kyseisen alihankintayrityksen kanssa.",
                title5: "Miten ilmoitan useamman kohteen samoilla tiedoilla? Esimerkiksi minulla on 4 samanlaista kalustoa vapaana samassa kohteessa samaan aikaan.",
                content5: "Helpoiten tämä onnistuu lisäämällä ensin yhden kalustoilmoituksen tarvittavilla tiedoilla, josta sitten tehdään 3 kopiota avaamalla kohteen tiedot luettelonäkymässä ja valitsemalla toiminto ”Kopioi Kalusto.",
                title6: "Miten saan parhaan hyödyn UnitSpotterista?",
                content6: "UnitSpotter on yhteistyöalusta, joten paras hyöty UnitSpotterista saavutetaan jakamalla tieto omista vapaista kalustoistaan ja/tai rahdeistaan muiden nähtäväksi. Kannattaa aina ensin lisätä kaikki omat kohteet UnitSpotteriin, ja tämän jälkeen etsiä muiden ilmoittamia sopivia kohteita. Ilmoittamalla omat kohteet, annetaan muille käyttäjille mahdollisuus nähdä ja ehdottaa niille kuljetusratkaisuja. Tämä voi tuoda esiin ratkaisuehdotuksia joita et ehkä olisi tullut ajatelleeksikaan."
            },
            newsItems: {
                title1: "Uusi kätevä nettityökalu huolinta- ja kuljetusliikkeille",
                content1: "Maaliskuussa avattu UnitSpotter yhteistyöalusta oli esillä Kuljetus & Logistiikka lehdessä (numero 2/2019), sekä Kuljetus ja Logistiikka messuilla.",
                link: "https://www.yumpu.com/fi/document/read/62622582/kuljetus-logistiikka-2-2019/9",
                readMore: "Lue lisää (Kuljetus & Logistiikka 2/2019)",

                title2: "Hangon Satama kasvaa ekologisesti",
                content2: "Hangon sataman ympäristöystävälliset investoinnit, sekä UnitSpotter yhteistyöalusta olivat esillä Helsingin Sanomien mainosliitteessä 5.2.2020.",
                link2: "https://issuu.com/contenthouseoy/docs/content_house_ympa_risto_/6",
                readMore2: "Lue lisää (Helsingin Sanomat 5.2.2020 - Content House Oy)",
                title3: "Tehokas Toimitusketju - Ajankohtainen julkaisu toimitusketjun kehittämisestä ja johtamisesta",
                content3: "Hangon Länsisataman laajennusprojekti ja UnitSpotter yhteistyöalusta olivat esillä Kauppalehden mainosliitteessä 15.12.2020 (sivulla 9).",
                link3: "http://project.mediaplanet.com/24361.pdf",
                readMore3: "Lue lisää (Mediaplanetin julkaisu 15.12.2020 - Suomi Mediaplanet Oy)"
            },
            userComments: {
                title: "Käyttäjien kommentit",
                text1: "”Helppokäyttöinen ja luotettava” (27.3.2020, mies, kuljetusala)",
                text2: "”Selkeästi luettavissa” (6.3.2020, mies, kuljetusala)",
                text3: "”Fiksu sovellus” (14.12.2019, mies, muu toimiala)",
                text4: "”Hyvä palvelu mikä tuottaa paljon hyötyä rantavetoihin” (26.11.2020, mies, huolinta-ala)",
            },
            newFeatures: {
                title: "UnitSpotter-palvelun uusia ominaisuuksia",
                title1: "Sähköpostimuistutukset",
                content1: "Nyt voit halutessasi myös tilata sähköpostimuistutuksia omiin ilmoituksiisi sopivista ilmoituksista. Sinun tarvitsee vain asettaa kilometriraja ja aktivoida seuranta oman ilmoituksesi tiedoista.",
                title2: "Zeckit palvelu kertoo toimijan taustatiedot",
                content2a: "Halusimme auttaa luotettavien yhteistyökumppaneiden löytämisessä, joten lisäsimme UnitSpotteriin Zeckit palvelun. Zeckit palvelu antaa käyttäjälle työkalut tarkistaa yritysten kaikki tärkeimmät tiedot, sekä asiakasarviot samasta paikasta helposti luettavassa ja selkeässä muodossa. Lue lisää Zeckit-selvityksen sisällöstä ja tulkinnasta",
                content2b: "sivulta.",
                title3: "Anna palautetta",
                content3: "Osallistu UnitSpotterin kehitykseen antamalla palautetta. Kehitämme UnitSpotteria käyttäjiltä saatujen palautteiden pohjalta ja haluammekin kuulla juuri sinun mielipiteet jotta voimme kehittää UnitSpotterista vielä paremman. Antamalla palautetta ja kertomalla käyttökokemuksistasi autat UnitSpotterin kehittämisessä.",
                title4: "Medialle",
                content4: "Katso myös UnitSpotter kuvakaappaukset sekä ohjeet logojen käytöstä medialle-sivulta, linkin löydät sivun alalaidasta.",
                title5: "Widget",
                content5: "UnitSpotter-palvelun käyttäjänä voit lisätä esimerkiksi kotisivuillesi widgetin, joka listaa yrityksesi UnitSpotter-palveluun lisäämät ilmoitukset. Kuvakaappauksen sekä ohjeet widgetin lisäämisestä löydät palveluun kirjautuneena Asetukset -> Widget & Partner API sivulta.",
                title6: "Partner rajapinta (API)",
                content6: "UnitSpotter-palvelun käyttäjänä voit hyödyntää myös ohjelmointirajapintaa (API), jonka kautta voit hakea omat aktiiviset ilmoituksesi, lisätä, poistaa, sekä päivittää ilmoituksiasi. Näin voit halutessasi integroida UnitSpotter-palvelun esimerkiksi käyttämääsi toiminnanohjaus- tai ajojärjestely-ohjelmistoon. Ohjeet löydät palveluun kirjautuneena Asetukset -> Widget & Partner API sivulta."
            }
        },
        statistics: {
            statistics: "Tilastot",
            reports: "Ilmoitetut",
            deletedTrucksAndUnits: "Poistetut",
            personalReports: "Omat",
            allReports: "Kaikki",
            reportsFromSystem: "Järjestelmän kautta tehdyt sopimukset",
            showOnlyPersonal: "Näytä vain omat", 

        },
        company: {
            company: "Yritys",
            companyContactDetails: "Yrityksen yhteystiedot",
            companySettings: "Yrityksen asetukset",
            ownCompany: "Oma yritys",
            personalAd: "Oma ilmoitus",
            accept: "Hyväksyn palvelun",
            termsOfUse: "Käyttöehdot.",
            companyDetails: "Yrityksen tiedot",
            contacts: "Yhteystiedot",
            companyDescription: "Yritysesittely",
            companyIndustryType: "Toimiala"
        },
        map: {
            legendDest: "Saapumispaikka",
            legendDep: "Lähtöpaikka",
            mapView: "Karttanäkymä",
            checkbox: {
                trucks: "Kalusto",
                units: "Rahti",
                routes: "Kaluston reitit",
                companies: "Yritykset"
            },
            toMapView: "Karttanäkymään"
        },
        login: {
            login: "Kirjaudu sisään",
            email: "Sähköposti",
            password: "Salasana",
            submitLogin: "Kirjaudu sisään",
            changePassword: "Vaihda salasana",
            oldPassword: "Vanha salasana",
            newPassword: "Uusi salasana",
            confirmNewPassword: "Uusi salasana uudelleen",
            loggingIn: "Kirjaudutaan sisään...",
            wrongEmailOrPassword: "Käyttäjätunnus tai salasana väärin!",
        },
        menus: {
            frontPage: "Etusivu",
            freeUnits: "Rahti",
            freeTrucks: "Kalusto",
            instructions: "Käyttöohje",
            termsOfService: "Käyttöehdot",
            privacyPolicy: "Tietosuojalauseke",
            filterSettings: "Filtterit"
        },
        trucks: {
            carrierCompany: "Kuljetusliike",
            truckDetailsHeader: "Kaluston tiedot",
            contractPrice: "Alustava hinta (€/km) (ei sitova)",
            contractPriceTitle: "Alustava hinta",
            companyDetailsHeader: "Ilmoittajan tiedot",
            reportNewTruck: "Ilmoita uusi kalusto",
            fillInTruckInformation: "Täytä tähän kaluston tiedot",
            availableFromDate: "Vapautumisen alkamispäivä",
            availableFromTime: "Vapautumisen alkamisaika",
            availableToDate: "Vapautumisen päättymispäivä",
            availableToTime: "Vapautumisen päättymisaika",
            licensePlateNumber: "Rekisterinumero",
            noPointOfArrival: "Ei saapumispaikkaa",
            recurringAdd: "Toisteinen ilmoitus",
            weeklyRecurringAdd: "Toisteinen viikottainen ilmoitus",
            editTruckTitle: "Muokkaa kalustoa",
            departingTrucks: "Lähtevät kalustot",
            truckRoutes: "Kalustojen reitit",
            maxThousandChars: 'Maksimissaan 1000 merkkiä',
            distance: "Reitin pituus",
            time: "Arvioitu matka-aika",
            properties: {
                adr: "ADR",
                explosive: "Räjähde",
                thermal: "Thermo",
                tank: "Säiliö",
                glass: "Lasi",
                mega: "Mega",
                container20: "Kontti 20",
                containerOver20: "Kontti yli 20",
                pieceGoods: "Kappaletavara",
                bulkGoods: "Irtotavara",
            },
            deleteReasons: {
                [DeleteReason.FoundCargoForTruckFromThisApp]: "Kalustolle löytyi tehtävä sovelluksen kautta",
                [DeleteReason.FoundCargoForTruckElsewhere]: "Kalustolle löytyi tehtävä sovelluksen ulkopuolella",
                [DeleteReason.ErrorTruckWasNotFree]: "Virhesyöttö, kalusto ei ollut vapaa",
                [DeleteReason.OtherReason]: "Muu syy, mikä?"
            },
            actions: {
                copy: "Kopioi kalusto",
                deleteTruck: "Kaluston poistaminen",
                sendEmailToAdvertiser: 'Lähetä ilmoittajalle sähköpostia',
                sendDetailsViaEmail: 'Lähetä tiedot sähköpostilla',
                noteForAdvertiser: "Viesti ilmoittajalle" ,
                noteForRecipient: "Viesti vastaanottajalle",
                recipientEmail: "Vastaanottajan sähköpostiosoite",

            },
            deleteTable: {
                departure: "Lähtöaika",
                arrival: "Saapumisaika",
                pointOfDeparture: "Lähtöpaikka",
                pointOfArrival: "Saapumispaikka",
            },
        },
        units: {
            unitDetailsHeader: "Rahdin tiedot",
            contractPrice: "Alustava hinta (€) (ei sitova)",
            companyDetailsHeader: "Ilmoittajan tiedot",
            contactPersonDetailsHeader: "Yhteyshenkilön tiedot",
            readyForDelivery: "Lähtövalmis",
            readyForDeliveryDate: "Lähtövalmiuspäivä",
            readyForDeliveryTime: "Lähtövalmiusaika",
            timeofDeliveryDate: "Toimituspäivä",
            timeOfDelivery: "Toimitusaika",
            fillInUnitInformation: "Täytä tähän rahdin tiedot",
            reportNewUnit: "Ilmoita vapaa rahti",
            containerNumber: "Konttinumero",
            unitIdentifier: "Tunniste",
            editUnitTitle: "Muokkaa rahtia",
            departingArrivingUnits: "Lähtevät ja saapuvat rahdit",
            properties: {
                adr: "ADR",
                explosive: "Räjähde",
                thermal: "Thermo",
                tank: "Säiliö",
                glass: "Lasi",
                mega: "Mega",
                container20: "Kontti 20",
                containerOver20: "Kontti yli 20",
                pieceGoods: "Kappaletavara",
                bulkGoods: "Irtotavara"
            },
            trailer: "Irtoperä",
            container: "Kontti",
            unspecified: "Yksiköimätön",
            deleteReasons: {
                [DeleteUnitReason.FoundTruckForUnitFromThisApp]: "Rahdille löytyi kalusto sovelluksen kautta",
                [DeleteUnitReason.FoundTruckForUnitElsewhere]: "Rahdille löytyi kalusto sovelluksen ulkopuolelta",
                [DeleteUnitReason.ErrorUnitWasNotFree]: "Virhesyöttö, rahti ei ollut vapaa",
                [DeleteUnitReason.OtherReason]: "Muu syy, mikä?"
            },
            deleteTable: {
                deleteUnit: "Rahdin poistaminen",
                departure: "Lähtöaika",
                arrival: "Saapumisaika",
                pointOfDeparture: "Lähtöpaikka",
                pointOfArrival: "Saapumispaikka",
            },
            actions: {
                copy: "Kopioi rahti",
                sendEmailToAdvertiser: 'Lähetä ilmoittajalle sähköpostia',
                sendDetailsViaEmail: 'Lähetä tiedot sähköpostilla',
                noteForAdvertiser: "Viesti ilmoittajalle" ,
                noteForRecipient: "Viesti vastaanottajalle",
                recipientEmail: "Vastaanottajan sähköpostiosoite",  
            },
        },
        actions: {
            addNew: "Lisää uusi",
            add: "Lisää",
            edit: "Muokkaa",
            delete: "Poista",
            ok: "OK",
            cancel: "Peruuta",
            report: "Ilmoita",
            continue: "Jatka",
            reset: "Tyhjennä",
            register: "Rekisteröidy",
            previous: "Edellinen",
            accept: "Hyväksy",
            reject: "Hylkää",
            logout: "Kirjaudu ulos",
            copy: "Kopioi",
            save: "Tallenna",
            next: "Seuraava",
            showOnMap: "Näytä kartalla",
            sendInfoByEmail: "Lähetä tiedot sähköpostilla",
            sendEmailToReporter: "Lähetä ilmoittajalle sähköpostia",
            send: "Lähetä",
            selected: "Valittu",
            added: "Lisätty",
            loading: "Ladataan...",
            show: "Näytä",
            toLoggingIn: "Siirry kirjautumiseen",
            loggingInView: "Kirjautumiseen",
            showOnMapView: "Näytä karttanäkymässä",
            describeDeleteReason: "Kuvaile poiston syytä",
            addedLowercase: "lisätty",
            markAsRead: "Merkkaa luetuksi",
            visible: "Näkyvissä",
            notVisible: "Ei näytetä",
            clear: "Tyhjennä",
            create: "Luo",
            createReport: "Luo ilmoitus",
        },
        validation: {
            required: "Pakollinen kenttä. ",
            notAnEmail: "Anna kelvollinen sähköpostiosoite. ",
            notAPhoneNumber: "Anna kelvollinen puhelinnumero. ",
            notABusinessID: "Anna kelvollinen Y-tunnus. ",
            notABusinessName: "Anna kelvollinen yrityksen nimi. ",
            notAnAddress: "Anna kelvollinen osoite. ",
            notAPostalCode: "Anna kelvollinen postinumero. ",
            notACity: "Anna kelvollinen toimipaikka. ",
            passwordsMatch: "Uusi salasana ei voi olla sama kuin vanha salasana.",
            newPasswordsMatch: "Salasanat eivät vastaa toisiaan.",
            validPassword: "Salasanan pitää sisältää vähintään 8 merkkiä, yksi iso kirjain, yksi pieni kirjain ja yksi numero.",
            endTimeAfterStartTime: "Loppuajankohdan tulee olla alkuajankohdan jälkeen.",
            maxLength1000: "Merkkijono saa sisältää maksimissaan 1000 merkkiä.",
            endingTimeError: "Loppuaika ei voi olla ennen alkuaikaa",
            passwordChanged: "Salasana vaihdettu",
            resetPassword: "Sinulle on lähetettu sähköposti, joka sisältää väliaikaisen salasanan.",
            passwordChangeError: "Salasanan vaihto epäonnistui.",
            truckCopyError: "Kaluston kopiointi epäonnistui.",
            truckAddingError: "Kaluston lisääminen epäonnistui.",
            identifierNotFound: "Tunnistetta ei löytynyt.",
            maxLength200: "Merkkijono saa sisältää maksimissaan 200 merkkiä.",
            valueBetween100And200: "Arvon täytyy olla välillä 100 - 200.",
            valueLessThan200: "Arvon täytyy olla välillä 0 - 200."
        },
        unitTypes: {
            [UnitType.Trailer]: "Irtoperä",
            [UnitType.Container20]: "Kontti 20",
            [UnitType.ContainerOver20]: "Kontti yli 20",
            [UnitType.Unspecified]: "Yksiköimätön"
        },
        filterTargetType: {
            [FilterTarget.Cargo]: "Rahti",
            [FilterTarget.Truck]: "Kalusto"
        },
        admin: {
            companiesTitle: "Yritykset",
            feedbackTitle: "Palautteet",
            registeredCompaniesTitle: "Rekisteröityneet yritykset",
            appliedCompaniesTitle: "Rekisteröitymistä hakeneet yritykset",
            registeredCompaniesTab: "Rekisteröityneet",
            appliedCompaniesTab: "Hakemuksen jättäneet",
            appliedCompanyInformationHeader: "Rekisteröitymistä hakeneen yrityksen tiedot",
            rejectedCompaniesTitle: "Hylätyt yritykset",
            rejectedCompaniesTab: "Hylätyt",
            rejectedCompanyInformationHeader: "Hylätyn yrityksen tiedot",
            rejectedAt: "Hakemus hylätty",
            acceptedAt: "Rekisteröitynyt",
            registeredAt: "Hakemus jätetty",
            registeredCompanyInformationHeader: "Rekisteröityneen yrityksen tiedot",
            companyEmployees: "Yritykseen liitetyt ajojärjestelijät",
            partnerApiKey: "Partner API tunniste"
        },
        recurrence: {
            recurringReport: "Toisteinen ilmoitus",
            daily: "Päivittäin",
            weekly: "Viikottain",
            monthly: "Kuukausittain",
            noEndDate: "Ei loppuaikaa",
            occurencesPreInput: "",
            occurencesPostInput: "tapahtuman jälkeen",
            untilPreInput: "",
            untilPostInput: "saakka",
            recurrenceStartDate: "Alkupäivä",
            recurrenceStartTime: "Alkuaika",
            recurrenceEndDate: "Toisteisuuden loppuaika",
            everyNthPreInput: "Joka ",
            dailyEveryNthPostInput: " päivä",
            weeklyEveryNthPostInput: " viikko",
            monthlyEveryNthPostInput: " kuukausi",
            everyWeekday: "Joka viikonpäivä",
            onDay: "Kuukauden ",
            dayRule: "Kuukauden",
            dayRuleMonth: "Kuukauden",
            weekdays: "Viikonpäivät",
            selectWeekday: "Valitse viikonpäivä",
        },
        days: {
            [DayOfWeek.Monday]: "Maanantai",
            [DayOfWeek.Tuesday]: "Tiistai",
            [DayOfWeek.Wednesday]: "Keskiviikko",
            [DayOfWeek.Thursday]: "Torstai",
            [DayOfWeek.Friday]: "Perjantai",
            [DayOfWeek.Saturday]: "Lauantai",
            [DayOfWeek.Sunday]: "Sunnuntai"
        },
        dayRules: {
            [DayRule.First]: "ensimmäinen",
            [DayRule.Second]: "toinen",
            [DayRule.Third]: "kolmas",
            [DayRule.Fourth]: "neljäs",
            [DayRule.Last]: "viimeinen"
        },
        dayRuleDays: {
            [DayRuleDay.Monday]: "maanantai",
            [DayRuleDay.Tuesday]: "tiistai",
            [DayRuleDay.Wednesday]: "keskiviikko",
            [DayRuleDay.Thursday]: "torstai",
            [DayRuleDay.Friday]: "perjantai",
            [DayRuleDay.Saturday]: "lauantai",
            [DayRuleDay.Sunday]: "sunnuntai",
            [DayRuleDay.Day]: "päivä",
            [DayRuleDay.Weekday]: "viikonpäivä",
            [DayRuleDay.WeekendDay]: "viikonlopun päivä"
        },
        settings: {
            settingsTitle: "Asetukset",
            personalDetails: "Omat tiedot",
            companyDetails: "Yrityksen tiedot",
            editCompany: "Muokkaa yritystä",
            editUser: "Muokkaa käyttäjää",
            visibilityRestrictionsTitle: "Näkyvyyden rajoittaminen",
            addVisibilityRestriction: "Lisää näkyvyysrajoite",
            deleteRestriction: "Poista rajoite",
            deleteUserConfirmationTitle: "Poiston varmistus",
            deleteUserQuestion: "Haluatko varmasti poistaa käyttäjän ",
            deleteUserDescription: "Poistamisen jälkeen käyttäjä ei pysty enää kirjautumaan järjestelmään.",
            deleteCompanyConfirmationTitle: "Poiston varmistus",
            deleteCompanyQuestion: "Haluatko varmasti poistaa yrityksen ",
            deleteCompanyDescription: "Yrityksen poistamisen yhteydessä myös kaikki yritykseen rekisteröityneet käyttäjät poistetaan.",
            deleteEmailConfirmationTitle: "Poiston varmistus",
            deleteEmailConfirmationQuestion: "Haluatko varmasti poistaa sähköpostin ",
            deletePhoneNumberConfirmationTitle: "Poiston varmistus",
            deletePhoneNumberConfirmationQuestion: "Haluatko varmasti poistaa puhelinnumeron ",
            allowPartnerTracking: "Salli yhteistyöseuranta yritystasolla",
            emailVisible: "Näytä sähköpostiosoite",
            showEmail: "Näytä sähköposti",
            phoneNumberVisible: "Näytä puhelinnumero",
            commonSettings: "Yleiset asetukset",
            joiningDay: "Liittymispäivämäärä",
            companyDescription: "Kuvaus yrityksestä, enintään 200 merkkiä.",
            filterSettings: "Filtterit",
            addNewFilter: "Lisää uusi filtteri",
            editFilterTitle: "Muokkaa filtteriä",
            copyFilter: "Kopioi filtteri",
            validUntil: "Voimassa asti",
            addNewFilterSetting: "Lisää kiinnostuksenkohde",
            editFilterSetting: "Muokkaa kiinnostuksenkohdetta",
            copyFilterSetting: "Kopioi kiinnostuksenkohde",
            fillInFilterSettingInformation: "Täytä tähän filtterin tiedot",
            widgetAndApiSettings: "Widget & Partner API",
            generateApiKey: "Luo tunniste widgetillesi",
            widgetInstructions: "Voit lisätä esimerkiksi kotisivuillesi alla näkyvän widgetin. Widget näyttää listalla oman yrityksesi UnitSpotter-palveluun lisäämät ilmoitukset. Aloita widgetin käyttö painamalla \"Luo tunniste widgetillesi\" painiketta, minkä jälkeen voit kopioida alta widgetin javascript-koodin ja liittää sen esimerkiksi kotisivuillesi. Liittämisen jälkeen widget ilmestyy sivuillesi, ja lataa generoimasi tunnisteen avulla yrityksesi jättämät ilmoitukset widgetissä listattavaksi.",
            partnerApiDescription: "UnitSpotter-palvelun käyttäjänä voit hyödyntää myös ohjelmointirajapintaa (API), jonka kautta voit hakea omat aktiiviset ilmoituksesi, lisätä, poistaa, sekä päivittää ilmoituksiasi. Näin voit halutessasi integroida UnitSpotter-palvelun esimerkiksi käyttämääsi toiminnanohjaus- tai ajojärjestely-ohjelmistoon.",
            partnerApiContainsFollowingFeatures: "Partner API:n HTTP REST-rajapinta sisältää seuraavat toiminnot",
            getUnits: "Omien aktiivisten rahti-ilmoitusten hakeminen",
            getTrucks: "Omien aktiivisten kalusto-ilmoitusten hakeminen",
            createUnit: "Uuden rahti-ilmoituksen lisääminen",
            createTruck: "Uuden kalusto-ilmoituksen lisääminen",
            deleteUnit: "Rahti-ilmoituksen poistaminen",
            deleteTruck: "Kalusto-ilmoituksen poistaminen",
            updateUnit: "Rahti-ilmoituksen päivittäminen",
            updateTruck: "Kalusto-ilmoituksen päivittäminen",
            partnerApiAuthenticationDescription: "Partner API:in tunnistaudutaan palvelun ylläpitäjän generoimalla PartnerApiKey tunnisteella, joka liitetään mukaan REST-rajapintaan tehtäviin http-pyyntöihin. Voit halutessasi testata rajapinnan toimintaa yleiskäyttöisellä testitunnuksella, joka on liitetty UnitSpotter-palvelun testiympäristöön. Huomioithan, että samaa testitunnusta voivat käyttää muutkin, joten pääsette hakemaan toistenne lisäämiä ilmoituksia.",
            partnerApiInstructions: "Tarkemmat tiedot rajapinnasta löydät testiympäristön rajapintakuvauksesta.",
            partnerApiTestKey: "Yleiskäyttöinen testitunnus testiympäristöön on",
            partnerApiContactInfo: "Mikäli haluat henkilökohtaisen testitunnuksen tai lisätietoja, ota yhteyttä palvelun ylläpitäjään (support@unitspotter.fi). Ota myös yhteyttä palvelun ylläpitäjään, jos olet kiinnostunut rajapinnan käytöstä tuotantoympäristössä.",
            partnerApiDevelopmentNotice: "Kehitämme parhaillaan ilmoitusten ominaisuus-listauksia, tämä voi aiheuttaa pieniä muutoksia rajapintaan, joten olethan yhteydessä jos haluat rakentaa integraation omaan järjestelmääsi.",
            partnerApiTestEmailInfo: "Yleiskäyttöisen testitunnuksen kanssa toimii ilmoitusten lisäyksen ja päivityksen yhteydessä ajojärjestelijän email test.person@mail.com (joka annetaan rajapintaan coordinatorEmail-kentässä).",
        },
        filterSettings: {
            filterSettingsDetailsHeader: "Filtterin tiedot",
            giveName: "Aseta filtterin nimi",
            name: "Filtterin nimi",
            type: "Filtterin tyyppi",
            target: "Filtterin kohde",
            activeFrom: "Aktiivinen lähtien",
            activeTo: "Voimassa asti",
            fillInfilterSettingsInformation: "Täytä tähän filtterin tiedot",
            editfilterSettingsTitle: "Muokkaa filtteriä",
            deletefilterSettingConfirmationTitle: "Poiston varmistus",
            deletefilterSettingQuestion: "Haluatko varmasti poistaa filtterin "
        },
        feedback: {
            giveFeedback: "Anna palautetta",
            contact: "support@unitspotter.fi",
            phone: "010 235 5010",

        },
        feedbackForm: {
            moreQuestions: "Jäikö kysyttävää?",
            feedback: "Otamme mielellämme vastaan palautteita, kysymyksiä ja kehitysehdotuksia palvelumme kehittämiseksi! Otathan meihin yhteyttä, niin vastaamme sinulle tarvittaessa mahdollisimman pian.",
            rating: "Arvosanasi palvelulle*",
            leaveFeedback: "Jätä palautetta",
            leaveFeedbackHere: "Kirjoita palautteesi tähän",

        },
        contact: {
            contactUs: "Ota yhteyttä",
            serviceProvidedBy: "Palvelun tarjoaa"
        },
        newsLetter: {
            newsletterDescription: "Kuule UnitSpotterin uusimmat kuulumiset ensimmäisten joukossa tilaamalla uutiskirjeemme.",
            subscribeToNewsletter: "Tilaa uutiskirje",
            subscribe: "Tilaa",
        },
        footer: {
            recommend: "Suosittele UnitSpotteria",
        },
        faqContainer: {
            frequentlyAskedQuestions: "Usein kysytyt kysymykset",
            hideQuestions: "Piilota kysymykset",
            moreQuestions: "Lisää kysymyksiä",
        },
        newsContainer: {
            unitSpotterinMedia: "UnitSpotter mediassa",
            hideNews: "Piilota uutiset",
            moreNews: "Lisää uutisia",
            readMore: "Lue lisää (Kuljetus & Logistiikka 2/2019)"
        },
        heroContainer: {
            title: "Kuljetusalan ammattilainen, siirretään yhdessä tyhjänä ajot historiaan!",
            desc: "Oletko miettinyt, miten voisit välttää tyhjänä ajoja ja parantaa kalustosi kustannustehokkuutta? Liity maksutta UnitSpotteriin, ratkaistaan se yhdessä!",
        },
        infoContainer: {
            infoboxTitle: "Miten UnitSpotter toimii?",
            infoboxTitle2: "Miten UnitSpotter tehostaa toimintaasi?",
            infoboxDesc1: "Tyhjäajot ovat globaali ongelma, joka koskee monia yrityksiä, ihmisiä, sekä ympäristöä. Eli meitä kaikkia. Tyhjäajo lisää kustannuksia, pidentää toimitusaikoja, sekä kuluttaa tiestöä ja luontoa. UnitSpotter on koko Suomen kattava helppokäyttöinen ja reaaliaikainen luotettavien toimijoiden yhteistyöalusta, joka on suunniteltu tasaamaan tyhjäajon ongelmaa ja samalla siihen liittyviä ja kumuloituvia ongelmakohtia.",
            infoboxDesc2: "Voit lisätä UnitSpotteriin omat ilmoituksesi vapaista rahdeista tai kalustoista. Voit myös selata muiden jättämiä ilmoituksia joko kartalla tai listanäkymässä. Voit hakea ilmoituksista juuri sinulle sopivaa kohdetta suodattamalla näkymää hakukriteeriesi mukaan ja näin löytää etsimäsi helposti ja nopeasti.",
            infoboxDesc3: "Oli kuljetustarpeesi Suomessa mihin suuntaan tahansa, ilmoittamalla kohteesi UnitSpotteriin muiden nähtäväksi, avaat muille käyttäjille mahdollisuuden ehdottaa kohteillesi kuljetusratkaisuja. Tämä voi tuoda esiin ratkaisuehdotuksia, joita et ehkä olisi tullut ajatelleeksikaan.",
            infoboxDesc4: "UnitSpotter. Koska uskomme, että yhteistyössä on voimaa!",
        },
        newsLetterDialog: {
            marketingPermission: "Markkinointilupa",
            marketingDesc: "Valitse ne viestintäkanavat joilla Port of Hanko Ltd. / UnitSpotter.fi saa olla yhteydessä sinuun.",
            viaEmail: "Sähköpostilla",
            viaText: "Tekstiviestillä",
            cancel: "Uutiskirjetilauksesi voit koska tahansa perua uutiskirjeen lopussa olevan linkin avulla. Tietosuojaselosteeseen voit tutustua osoitteessa:",
            mailChimp: "We use Mailchimp as our marketing platform. By clicking below to subscribe, you acknowledge that your information will be transferred to Mailchimp for processing.",
        },
        quotesContainer: {
            personsRecommend: "Palveluamme suosittelevat",
        },
        forms: {
            addEmail: "Lisää sähköposti",
            editEmail: "Muokkaa sähköpostia",
            addPhone: "Lisää puhelinnumero",
            editPhone: "Muokkaa puhelinnumeroa",
            addRestriction: "Valitse alla olevasta listasta yritykset, joille et halua näyttää yrityksesi tietoja, ajojärjestelijöiden ilmoittamia kalustoja ja rahteja. Tällöin myöskään sinä et näe kyseisen yrityksen tietoja tai ilmoituksia.",
        },
        store: {
            contactAddError: "Yhteystietojen lisääminen epäonnistui",
            contactAddSuccess: "Puhelinnumeron muokkaus onnistui",
            addEmailSuccess: "Sähköpostin muokkaaminen onnistui",
            feedBackSuccess: "Palaute lähetetty",
            feedBackError: "Palautteen lähetys epäonnistui",
        },
        zeckit: {
            viewCompanyStatement: "Katso yrityksen selvitys Zeckitistä"
        },
        notifications: {
            addNotification: "Lisää ilmoitus",
            notification: "Ilmoitus",
            redirectUsersTo: "Ohjaa käyttäjät sivulle",
            remindLater: "Muistuta myöhemmin",
            goTo: "Siirry",
            close: "Sulje"
        },
        companyIndustryTypes: {
            [CompanyIndustryType.Transportation]: "Kuljetus-/Huolintaliike",
            [CompanyIndustryType.Retail]: "Kauppa/Teollisuus",
            [CompanyIndustryType.Other]: "Muu toimiala"
        }
    },
});




// WEBPACK FOOTER //
// ./src/localization/localization.ts